{
  "pageTitle": "Ережелер мен саясаттар",
  "pageIntro": "Төмендегі құжаттар VBB PLAY үшін жоба. Компания атауы, лицензия және қолданылатын құқық иесі растағанға дейін өндіріске дайын емес.",
  "draftBadge": "ЖОБА — бекіту күтілуде",
  "backToList": "Барлық ережелерге оралу",
  "updatedLabel": "Нұсқа",
  "version": "0.2-draft",
  "footerNote": "Бұл бекітілген заң мәтіні емес. Тірі сайтқа тек бөлек рұқсаттан кейін шығарылады.",
  "navTitle": "Ережелер",
  "categories": {
    "terms": {
      "title": "Пайдалану ережелері",
      "summary": "Аккаунт ашу, платформаны пайдалану және негізгі міндеттер.",
      "sections": [
        {
          "heading": "1. Жалпы",
          "body": "VBB PLAY — онлайн ойын және байланысты қызметтер платформасы. Тіркелу немесе пайдалану осы ережелерді қабылдауды білдіреді. Ресми компания атауы, тіркеу елі және лицензия иесі растағаннан кейін қосылады."
        },
        {
          "heading": "2. Аккаунт",
          "body": "Әр пайдаланушыда тек бір жеке аккаунт болуы мүмкін. Кіру деректерінің құпиялылығына сіз жауаптысыз."
        },
        {
          "heading": "3. Жас және жарамдылық",
          "body": "Қызмет тек заңды жасқа толғандарға арналған. Тексеру қажет болуы мүмкін."
        },
        {
          "heading": "4. Тыйым салынған әрекеттер",
          "body": "Алаяқтық, автоматтандыруды теріс пайдалану және заңсыз әрекетке тыйым салынады."
        },
        {
          "heading": "5. Қызмет өзгерісі",
          "body": "Функциялар мен каталог алдын ала хабарлаумен өзгертілуі немесе уақытша тоқтатылуы мүмкін."
        },
        {
          "heading": "6. Байланыс",
          "body": "Даулар мен сұрақтар үшін Тікелей қолдауды пайдаланыңыз."
        }
      ]
    },
    "privacy": {
      "title": "Құпиялылық саясаты",
      "summary": "Жеке деректерді жинау, сақтау және пайдалану.",
      "sections": [
        {
          "heading": "1. Қандай деректер",
          "body": "Аккаунт, байланыс, төлем метадеректері, техникалық журналдар және қолдау хат алмасуы өңделуі мүмкін."
        },
        {
          "heading": "2. Мақсат",
          "body": "Деректер аккаунтты басқару, қауіпсіздік, төлемдер, қолдау және заңды міндеттер үшін қолданылады."
        },
        {
          "heading": "3. Бөлісу",
          "body": "Деректер сатылмайды; төлем/ойын провайдерлеріне және заң бойынша органдарға берілуі мүмкін."
        },
        {
          "heading": "4. Сақтау мерзімі",
          "body": "Қызмет пен заң үшін қажет мерзім сақталады, кейін жойылады немесе анонимделеді."
        },
        {
          "heading": "5. Құқықтарыңыз",
          "body": "Қолдау арқылы қол жеткізу, түзету немесе жою сұрауын жібере аласыз."
        },
        {
          "heading": "6. Қауіпсіздік",
          "body": "Техникалық және ұйымдастыру шаралары қолданылады; толық тәуекелсіз жүйе жоқ."
        }
      ]
    },
    "bonuses": {
      "title": "Бонус ережелері",
      "summary": "Бонустар, промокодтар және сәттілік дөңгелегі шарттары.",
      "sections": [
        {
          "heading": "1. Жалпы",
          "body": "Бонустар кампания шарттары мен аккаунт мәртебесіне байланысты."
        },
        {
          "heading": "2. Нақты және бонус балансы",
          "body": "Қаражат бөлек есептеледі. Бонус ойыны тек рұқсат етілген ойындарда."
        },
        {
          "heading": "3. Вейджер",
          "body": "Айналым талаптары кампанияда көрсетіледі; орындалмаса бонус жойылуы мүмкін."
        },
        {
          "heading": "4. Теріс пайдалану",
          "body": "Көп аккаунт немесе шарттарды айналып өту бонустың жойылуына әкелуі мүмкін."
        },
        {
          "heading": "5. Өзгерістер",
          "body": "Кампаниялар тоқтатылуы немесе өзгертілуі мүмкін."
        }
      ]
    },
    "payments": {
      "title": "Депозит және шығару",
      "summary": "Төлем әдістері, лимиттер және тексеру.",
      "sections": [
        {
          "heading": "1. Депозит",
          "body": "Тек белсенді әдістер қабылданады. Қате желі/деректеме/сомма кідіріске немесе жоғалтуға әкелуі мүмкін."
        },
        {
          "heading": "2. Шығару",
          "body": "Өтінімдер тексерілуі мүмкін; KYC талап етілуі мүмкін."
        },
        {
          "heading": "3. Валюта",
          "body": "Негізгі валюта платформада көрсетілген валюта."
        },
        {
          "heading": "4. Чектер",
          "body": "Кей әдістерде чек немесе қосымша растау керек. Жалған құжатқа тыйым."
        },
        {
          "heading": "5. Қайтару",
          "body": "Қате операциялар қолдау және серіктестер арқылы фактілер бойынша қаралады."
        }
      ]
    },
    "responsible": {
      "title": "Жауапты ойын",
      "summary": "Өзін шектеу және зиянды мінез-құлықтың алдын алу.",
      "sections": [
        {
          "heading": "1. Қағида",
          "body": "Ойын — ойын-сауық. Ұтыс кепілденбейді."
        },
        {
          "heading": "2. Құралдар",
          "body": "Салқындату, өзін шектеу және жабу сұрауы қолжетімді болуы мүмкін."
        },
        {
          "heading": "3. Көмек",
          "body": "Тәуекел сезсеңіз, кәсіби көмек алыңыз."
        },
        {
          "heading": "4. Кәмелетке толмағандар",
          "body": "Қатысуға тыйым; мұндай аккаунттар жабылады."
        }
      ]
    },
    "kyc": {
      "title": "Аккаунтты растау (KYC)",
      "summary": "Жеке басын және байланысты тексеру.",
      "sections": [
        {
          "heading": "1. Қашан",
          "body": "Шығару, ірі сомма, тәуекел немесе заң бойынша KYC сұралуы мүмкін."
        },
        {
          "heading": "2. Құжаттар",
          "body": "Жеке куәлік, мекенжай және төлем дәлелі қажет болуы мүмкін."
        },
        {
          "heading": "3. Өңдеу",
          "body": "Деректер тек тексеру үшін және құпиялылық саясаты бойынша сақталады."
        },
        {
          "heading": "4. Нәтиже",
          "body": "Тексеру аяқталғанша операциялар шектелуі мүмкін."
        }
      ]
    },
    "aml": {
      "title": "AML және алаяқтыққа қарсы",
      "summary": "Күдікті операциялардың алдын алу.",
      "sections": [
        {
          "heading": "1. Мақсат",
          "body": "Платформа ақшаны жылыстату мен алаяқтықтың алдын алуға ұмтылады."
        },
        {
          "heading": "2. Мониторинг",
          "body": "Операциялар мен мінез-құлық автоматты және/немесе қолмен тексерілуі мүмкін."
        },
        {
          "heading": "3. Шаралар",
          "body": "Күдік кезінде депозит/шығару тоқтатылып, аккаунт қатырылуы мүмкін."
        },
        {
          "heading": "4. Ынтымақтастық",
          "body": "Пайдаланушылар қолдау сұрауларына уақтылы жауап беруі керек."
        }
      ]
    },
    "fairplay": {
      "title": "Әділ ойын және жас",
      "summary": "Ойын әділдігі, провайдер ережелері және жас шектеуі.",
      "sections": [
        {
          "heading": "1. Провайдерлер",
          "body": "Ойындарды үшінші тарап провайдерлері ұсынуы мүмкін; олардың ережелері қолданылады."
        },
        {
          "heading": "2. Нәтижелер",
          "body": "Нәтижені провайдер жүйесі анықтайды."
        },
        {
          "heading": "3. Жас",
          "body": "Нақты ақша ойыны тек заңды жастағыларға."
        },
        {
          "heading": "4. Тіл",
          "body": "Провайдер интерфейсі тек қолдау көрсетілетін тілдерде көрсетіледі."
        }
      ]
    },
    "self_exclusion": {
      "title": "Өзін шектеу саясаты",
      "summary": "Салқындату, өзін шектеу және аккаунтты уақытша немесе тұрақты шектеу.",
      "sections": [
        {
          "heading": "1. Мақсат",
          "body": "Бұл саясат ойын әрекетін тоқтату немесе шектеу құралдарын ұсынады."
        },
        {
          "heading": "2. Құралдар",
          "body": "Салқындату, өзін шектеу және жабу сұрауы профиль/қауіпсіздік немесе Тікелей қолдау арқылы қолжетімді болуы мүмкін."
        },
        {
          "heading": "3. Әсері",
          "body": "Өзін шектеу белсенді кезде депозит, ойын немесе басқа әрекеттер шектелуі мүмкін. Мерзім аяқталмай тұрып алып тастау әдетте мүмкін емес."
        },
        {
          "heading": "4. Сұрау процесі",
          "body": "Қолдау сұраулары тексеріледі. Жеке басын растау қажет болуы мүмкін."
        },
        {
          "heading": "5. Жауапкершілік",
          "body": "Құралдар тәуекелді азайтады, бірақ кәсіби көмекті алмастырмайды."
        },
        {
          "heading": "6. Заңды ескертпе",
          "body": "Компания деректері мен қолданылатын құқық иесі растағаннан кейін қосылады. Бұл жоба мәтін."
        }
      ]
    },
    "disputes": {
      "title": "Дауларды шешу саясаты",
      "summary": "Төлем, бонус, ойын нәтижесі және аккаунт дауларын қарау тәртібі.",
      "sections": [
        {
          "heading": "1. Қамту",
          "body": "Депозит/шығару, бонус, аккаунт мәртебесі және ойын сеанстары бойынша даулар."
        },
        {
          "heading": "2. Алғашқы жүгіну",
          "body": "Алдымен Тікелей қолдауға жазыңыз. Өтінім нөмірі, күні, сомасы және дәлелдерді қосыңыз."
        },
        {
          "heading": "3. Тексеру",
          "body": "Қолдау журналдар мен төлем/провайдер деректерін тексере алады."
        },
        {
          "heading": "4. Мерзім",
          "body": "Қарапайым істер тезірек қаралады; күрделі тексерулер ұзағырақ созылуы мүмкін."
        },
        {
          "heading": "5. Нәтиже",
          "body": "Шешім фактілерге негізделеді. Жасанды құжаттар шектеуге әкелуі мүмкін."
        },
        {
          "heading": "6. Эскалация",
          "body": "Қосымша эскалация жолы мен заңды мекенжай иесі растағаннан кейін қосылады. Бұл жоба мәтін."
        }
      ]
    }
  }
}
